<script>
    let actors = [
        {
            name: "Jon Andersson",
            text: "PhD Biology, Forest and GIS Expert"
        },
        {
            name: "Per Angelstam",
            text: "Professor, Forest and natural resource management and governance Swedish University of Agricultural Sciences, Faculty of Forest Sciences"
        },
        {
            name: "Mary S. Booth",
            text: "PhD Ecology - Director, Partnership for Policy Integrity"
        },
        {
            name: "Anders Dahlberg",
            text: "Professor, Swedish University of Agricultural Sciences Department of Forest Mycology and Plant Pathology"
        },
        {
            name: "Lena Gustafsson",
            text: "Professor Emeritus, Swedish University of Agricultural Sciences Department of Ecology"
        },
        {
            name: "Stig-Olof Holm",
            text: "PhD Ecology, Umeå University Department of Ecology and Environmental Sciences"
        },
        {
            name: "Bengt Gunnar Jonsson",
            text: "Professor - Mid Sweden University Department of Natural Sciences"
        },
        {
            name: "Artur Larsson",
            text: "Conservation biologist - System manager Swedish Species Information Centre"
        },
        {
            name: "Anders Lindroth",
            text: "Professor Emeritus, Lund University Department of Physics Geography and Ecosystem Science"
        },
        {
            name: "Erik Westholm",
            text: "Professor Emeritus, Swedish University of Agricultural Sciences Dept for Urban and Rural Studies"
        },
        {
            name: "Lars Östlund",
            text: "Professor, Forest History, Swedish University of Agricultural Sciences Department of Forest Ecology and Management"
        },
    ]
</script>
<div class="appearing-section">
    <h2 class="text-center" id="appearing">Appearing</h2>
    <p class="bold text-center subheader">Scientists and experts appearing in the film, in alphabetical order:</p>
    {#each actors as actor}
         <div class="actor">
             <strong>{actor.name},</strong> {actor.text}
         </div>
    {/each}
</div>

<style>
    .actor {
        padding-bottom: 0.8rem;
        font-family: 'Open Sans', sans-serif;
        font-size: 0.9rem;
    }
    .appearing-section {
        padding: 0rem 0rem;
    }
</style>